module.exports = __webpack_public_path__ + "img/2021.c2b74ca8.jpg";